export default class FriendRequest {
  constructor(data) {
    this.id = data.id || ""; 
    this.name = data.name || "";
    this.imageURL = data.image_url || ""; // изменено
    this.specifics = data.specifics || "";
  }
}